import React, { FC, ReactNode } from 'react';
import { Tooltip as BSTooltip, OverlayTrigger } from 'react-bootstrap';

interface Props {
  tooltip: string | React.ReactElement;
  children: ReactNode;
}

export const Tooltip: FC<Props> = (props) => {
  if (!props.tooltip) {
    return props.children;
  }

  return (
    <OverlayTrigger placement="top" overlay={<BSTooltip id="t">{props.tooltip}</BSTooltip>}>
      <span>{props.children}</span>
    </OverlayTrigger>
  );
};
